import { CARCS } from '../config'
import { getBaseCarcCode } from './get-mapped-rarc-options'

export function getCarcLabelByCode(code: string) {
  const base = getBaseCarcCode(code)
  const codeObj = CARCS.find((c) => getBaseCarcCode(c.code) === base)
  return codeObj?.label ?? null
}
